<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="projectsService"
    [idKey]="'projectId'"
/>